import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { i18nGotowe } from "./i18n";
import "./index.css";
import { czyMoznaPrzeladowac, przeladujPoBledzieModulu } from "./lib/samonaprawaWdrozenia";

// Leaflet (ikony, CSS) NIE jest tu ładowany: src/lib/map/leafletUstawienia.ts importują komponenty
// z mapą Leafleta — wyszukiwarka rysuje MapLibre i Leafleta na starcie nie potrzebuje.

// Stale-chunk recovery: after a new deploy, an already-open tab still references the previous
// build's hashed lazy chunks. Vite fires `vite:preloadError` for exactly this, BEFORE the error
// reaches the route's ErrorBoundary — so it must go through the same self-heal: repair poisoned
// HTTP-cache entries across the chunk's whole static import graph, then reload once per build
// (src/lib/samonaprawaWdrozenia.ts). A bare reload here used to fire first and skip the repair.
window.addEventListener('vite:preloadError', (e) => {
  const blad = (e as Event & { payload?: unknown }).payload;
  if (czyMoznaPrzeladowac()) void przeladujPoBledzieModulu(blad);
});

// Own scroll positioning outright. Mobile browsers re-apply a remembered
// scroll offset asynchronously — AFTER our route-change reset has run — which
// left screens arriving with their title tucked under the sticky header (seen
// on iOS Chrome, 2026-07-27). ScrollToTop + the shells' own resets are the
// single source of truth for where a screen starts.
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

// Pierwszy render dopiero z gotowym słownikiem: dla polskiego od razu (jest w paczce), dla
// en/ua/by po dociągnięciu — inaczej przez chwilę byłyby widoczne klucze zamiast tekstu.
void i18nGotowe.finally(() => createRoot(document.getElementById("root")!).render(<App />));
